import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { routerUrls } from '@/configs/routes/routerUrls';
import { useUserStore } from '@/configs/store';
import { clearKtsidLoginMark, hasKtsidLoginMark } from '@/utils/ktsidLoginMark';
import { getLegacyLoginUrl } from '@/utils/legacyLoginUrl';

import { useYandexTokenWarning } from './useYandexTokenWarning';

/** Страницы старого учёта: логи в Яндекс Трекере, без его токена они не работают */
const YandexOutlet = observer(() => {
  const { hasYandexAccess } = useUserStore();
  const location = useLocation();
  // Только чтение: в StrictMode инициализатор вызывается дважды, отметку снимаем в эффекте
  const [fromKtsidLogin] = useState(hasKtsidLoginMark);

  useYandexTokenWarning();

  useEffect(() => {
    if (fromKtsidLogin) clearKtsidLoginMark();
  }, [fromKtsidLogin]);

  // Вход через KTSID ведёт в новый учёт: бэк вернул на главную, но токена Яндекса может и не быть
  if (fromKtsidLogin) {
    return <Navigate to={routerUrls.v2.table} replace />;
  }

  if (!hasYandexAccess) {
    return <Navigate to={getLegacyLoginUrl(location.pathname + location.search)} replace />;
  }

  return <Outlet />;
});

export default YandexOutlet;
